module.exports = new __parcel__URL__("exercise1.0f3a35eb.png").toString();